// extracted by mini-css-extract-plugin
module.exports = {"list":"TodoList_list__1FTY3","btn":"TodoList_btn__1piO-","icon":"TodoList_icon__3ux-X","text":"TodoList_text__IyDCw"};